import { z } from 'zod'

export const TargetingTagScore = z.object({
  /**
   * The targeting tag identifier (e.g., "tech_enthusiast", "luxury_shopper").
   * This is a unique string used to categorize user interests or attributes.
   */
  tag: z.string(),

  /**
   * Confidence score representing how strongly this tag applies.
   * Values range from 0.0 (no match) to 1.0 (perfect match), inclusive.
   */
  score: z.number(),

  /**
   * Provides transparency about how this score was determined.
   */
  reasoning: z
    .object({
      /**
       * Array of credential slugs that contributed to this targeting score.
       * References the specific credentials used in the evaluation.
       */
      slugs: z.string().array(),

      /**
       * Human-readable explanation of why this targeting tag applies
       * and how the score was calculated.
       */
      explanation: z.string(),
    })
    .optional(),
})
export type TargetingTagScore = z.infer<typeof TargetingTagScore>
